var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:1.5001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.97,6.3l-8.52,8.52c-1.8,1.8-1.89,4.64-0.19,6.33c1.69,1.69,4.53,1.6,6.33-0.19l9.82-9.82 c2.72-2.81-1.27-7.12-4.19-4.19l-9.82,9.82c-0.66,0.66-0.69,1.7-0.07,2.32l0,0c0.62,0.62,1.66,0.59,2.32-0.07l8.52-8.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.dcf24d148eecb090abb0c77c1967b505.svg";
export { ForwardRef as ReactComponent };